import type {SyncConfigComponentProps} from '@cohort/merchants/apps';
import ImportUsersConfig from '@cohort/merchants/apps/postgresql/sync/ImportUsersConfig';
import SwitchInput from '@cohort/merchants/components/form/SwitchInput';
import HighlightText from '@cohort/merchants/components/HighlightText';
import {useCohortForm} from '@cohort/merchants/hooks/contexts/form';
import type {SyncConfigFormValues} from '@cohort/merchants/pages/apps/app/utils';
import {useTranslation} from 'react-i18next';

const PostgresqlSyncConfigComponent: React.FC<SyncConfigComponentProps> = ({connection}) => {
  const {sync} = connection;
  const {t} = useTranslation('app-postgresql', {
    keyPrefix: 'sync.syncConfigComponent',
  });

  const {register, control, watch} =
    useCohortForm<Extract<SyncConfigFormValues, {appId: 'postgresql'}>>();

  const isImportEnabled = watch('userImportEnabled');

  return (
    <div className="mb-24 space-y-6">
      <div className="flex flex-col gap-6 rounded-lg border border-slate-200 p-6">
        <div className="flex items-center gap-2">
          <SwitchInput
            name="userImportEnabled"
            label={t('labelEnableUserImport')}
            labelPosition="right"
            register={register}
            control={control}
          />
        </div>
        {sync !== null && sync.userSyncConfig !== null && !isImportEnabled && (
          <HighlightText text={t('highlightTextUserImportDisabledWarning')} type="warning" />
        )}
        <ImportUsersConfig connection={connection} />
      </div>
    </div>
  );
};

export default PostgresqlSyncConfigComponent;
